import { defineComponent as u, computed as t, openBlock as d, createElementBlock as m, normalizeClass as b, toDisplayString as f } from "vue";
import { isEmpty as g } from "../../utils/isEmpty.js";
import { tw as a } from "../../utils/tailwind.js";
const v = ["aria-label", "aria-labelledby"], y = /* @__PURE__ */ u({
  name: "RevBadge",
  __name: "Badge",
  props: {
    ariaLabel: { default: () => {
    } },
    ariaLabelledby: { default: () => {
    } },
    count: { default: 0 },
    maxCount: { default: 99 },
    size: { default: "large" },
    variant: { default: "default" }
  },
  setup(e) {
    const n = t(() => e.count === 0 ? null : e.count > e.maxCount ? `${e.maxCount}+` : e.count), s = t(() => !g(n.value)), c = t(() => {
      const i = a`text-static-default-hi mood-inverse rounded-lg caption-bold inline-block max-w-full truncate`, l = a`min-w-20 px-4 text-center`, r = {
        small: a`size-6`,
        medium: a`size-8`,
        large: a`size-12`
      }, o = {
        default: a`bg-static-danger-hi`,
        accent: a`bg-static-accent-mid`,
        // Deprecated variants are aliased to `default` for the Color Refresh Phase 2.
        danger: a`bg-static-danger-hi`,
        warning: a`bg-static-danger-hi`,
        success: a`bg-static-danger-hi`,
        info: a`bg-static-accent-mid`
      };
      return [
        i,
        o[e.variant],
        s.value ? l : r[e.size]
      ];
    });
    return (i, l) => (d(), m("span", {
      "aria-label": e.ariaLabel,
      "aria-labelledby": e.ariaLabelledby,
      "aria-live": "polite",
      class: b(c.value),
      role: "status"
    }, f(n.value), 11, v));
  }
});
export {
  y as default
};
